<script>
import { mapGetters, mapMutations } from 'vuex';
import stepsMixin from '@/mixins/stepsMixin'
export default {
	mixins: [stepsMixin],
	props: ['client'],
	components: {
		SvgIcon: () => import('@/components/SvgIcon'),
	},
	data() {
		return {
			name: 'analisis_basico',
			form: {
				path: 'Generico',
				grupo: '',
				comentarios: '',
				leveraged: '',
				cualitativo: '',
				reestructuradoRefinanciado: '',
				reestructuradoRefinanciadoComentarios: '',
				tipoCompania: '',
				experienciaAdministracion: '',
				experienciaAdministracionComentarios: '',
			},
			shareholdersForm: [
				{
					nombre: '',
					participacion: '',
					financialSponsor: '',
					ano: '',
					query: ''
				}
			],
			shareholders: []
		}
	},

	computed: {
		showShareholders() {
			let data = this.shareholders.filter(sh => {
				return sh.nombre && sh.participacion
			})

			return data
		},

		...mapGetters({
			showHelp: 'arceStatus/showHelp'
		})
		
	},
	watch: {
		'client': {
			handler(nVal) {
				this.fillForm()
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		calcFill() {
			let fields = Object.keys(this.form)
			if(this.form.reestructuradoRefinanciado == 'NO') {
				let index = fields.indexOf('reestructuradoRefinanciadoComentarios')
				fields.splice(index, 1)
			}

			let points = 100 / fields.length

			let fill = 0

			fields.forEach(f => {
				if(this.form[f]) {
					fill += points
				}
			})

			return Math.round(fill)
		},
		addNew() {
			
			this.shareholdersForm.push(
				{
					nombre: '',
					participacion: '',
					financialSponsor: '',
					ano: '',
					query: ''
				}
			)
		},
		deleteItem(index) {
			this.shareholdersForm.splice(index, 1)
		},
		showModal(id) {
			if(document.querySelectorAll(`${id}`).length > 1) {
				$(`body > ${id}`).remove()
				this.showModal(id)
			} else {
				$(id).appendTo("body").modal('show')

			}
		},
		openModalShareholders() {
			this.$set(this, 'shareholdersForm', [...this.shareholders.map(sh => ({...sh}))])
			this.showModal('#accionistasModal')
		},

		saveAllShareholders() {
			this.$set(this, 'shareholders',  [...this.shareholdersForm.map(sh => ({...sh}))])

			this.$notify({
				type: 'success',
				group: 'simulator',
				title: 'Success!',
				text: 'The record has been saved successfully'
			})
		},

		save() {
			let vm = this
			let payload =  {
				client:  this.client,
				form: this.name,
				data: Object.assign({...this.form}, {shareholders: [...this.shareholders]}),
				fill: vm.calcFill()
			}
			vm._setDataChild(payload)
			vm.$emit('updateArce')
			vm.hiddenSteps()
			vm.showSteps('stepsArceDetails', 11)
		},

		openEdit() {
			
			this.hiddenSteps()
			this.showModal('#formAnalysisModal')
			setTimeout(() => {
				this.showSteps('stepsAnalysisBasicEdit')
			}, 400)
		},
		fillForm() {
			let data = {}
			if(this.client.arce.hasOwnProperty(this.name)) {
				data = {...this.client.arce[this.name]}
			}
			if(!Object.keys(data).length) {
				this.$set(this, 'form', {
					path: 'Generico',
					grupo: '',
					comentarios: '',
					leveraged: '',
					cualitativo: '',
					reestructuradoRefinanciado: '',
					reestructuradoRefinanciadoComentarios: '',
					tipoCompania: '',
					experienciaAdministracion: '',
					experienciaAdministracionComentarios: '',
				})
				this.$set(this, 'shareholders', [
					{
						nombre: '',
						participacion: '',
						financialSponsor: '',
						ano: '',
						query: ''
					}
				])

				return 
			}
			this.$set(this, 'shareholders', data.shareholders || [...this.shareholders])
			delete data['shareholders']
			this.$set(this, 'form', data)
		},
		
		closeModal() {
			this.hiddenSteps()
			this.fillForm()
		},
		...mapMutations({
			_setDataChild: 'arceDetails/setDataChild'
		})
		// ...mapMutations({
		// 	setShareholders: 'arceDetails/setShareholders'
		// })
	},
	mounted() {
		$('#formAnalysisModal').on('hide.bs.modal', this.closeModal)
	},

	beforeDestroy() {
		$('#formAnalysisModal').off('hide.bs.modal', this.closeModal)
	}
	
}
</script>
<template>
	<div style="">
		<div class="text-right py-2">
			<button class="s-btn s-btn--primary" @click="openEdit" data-v-step="ad11">
				Editar
			</button>
		</div>
		<div>
			<div class="s-collapse__header" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
				<div class="d-flex">
					<h1 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span>Path</span></h1>
				</div>
			</div>
			<div id="collapseOne" class="collapse show" aria-labelledby="headingOne">
				<div class="d-flex flex-wrap">
					<div class="col-12 col-md-6">
						
						<div class="h-100 py-2">
							<p class="m-0"><span class="text-danger">*</span> Template</p>
							<div>
								<select class="form-control form-control--disabled" disabled name="" v-model="form.path">
									<option value=""></option>
									<option value="Generico">Generico</option>
									<option value="Construcción">Construcción</option>
									<option value="Hoteles">Hoteles</option>
									<option value="Agro">Agro</option>
									<option value="Retail">Retail</option>
									<option value="Auto Retail">Auto Retail</option>
								</select>
							</div>
						</div>
					</div>
							
				</div>
			</div>
			<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
				<div class="d-flex">
					<h1 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Identificación</span></h1>
				</div>
			</div>
			<div id="collapseTwo" class="collapse hide" aria-labelledby="headingOne">
				<div class="d-flex flex-wrap">
					<div class="col-4 p-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Grupo</p>
							<select class="form-control form-control--disabled w-100" disabled name="gupo" v-model="form.grupo">
								<option value="" disabled></option>
								<option value="Pertenece a un grupo económico">Pertenece a un grupo económico</option>
								<option value="No pertenece a un grupo económico">No pertenece a un grupo económico</option>
							</select>
						</label>
					</div>
					<div class="col-4 p-2">
						<label class="d-block m-0">
							<p class="m-0">Nombre del cliente</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="client.name">
						</label>
					</div>
					<div class="col-4 p-2"></div>
					<div class="col-4 p-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Comentarios</p>
							<textarea class="form-control w-100 d-block form-control--disabled" disabled rows="3" v-model="form.comentarios"></textarea>
						</label>
					</div>
					<div class="col-4 p-2">
						<label class="d-block m-0">
							<p class="m-0">País Cabecera</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="client.pais_cabecera">
						</label>
					</div>
					<div class="col-4 p-2">
						<label class="d-block">
							<p class="m-0">RFC</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="client.rfc">
						</label>
					</div>
					<div class="col-4 p-2">
						<label class="d-block">
							<p class="m-0">Número de cliente</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="client.code">
						</label>
					</div>
					<div class="col-4 p-2">
						<label class="d-block">
							<p class="m-0">Sector (asset allocation)</p>
							<input class="form-control form-control--disabled" disabled type="text" value="Capital goods & Industrial services">
						</label>
					</div>
					<div class="col-4 p-2">
						<label class="d-block">
							<p class="m-0">Subsector (asset allocation)</p>
							<input class="form-control form-control--disabled" disabled type="text" value="Capital goods & Industrial services">
						</label>
					</div>
					<div class="col-4 p-2">
						<label class="d-block">
							<p class="m-0">Actividad (banxico)</p>
							<input class="form-control form-control--disabled" disabled type="text" :value="client.activity">
						</label>
					</div>
					<div class="col-4 p-2">
						<label class="d-block">
							<p class="m-0">Fundada desde</p>
							<input class="form-control form-control--disabled" disabled type="text" :value="client.since">
						</label>
					</div>
					<div class="col-4 p-2">
						<label class="d-block">
							<p class="m-0">Cliente desde</p>
							<input class="form-control form-control--disabled" disabled type="text" :value="client.clientSince">
						</label>
					</div>
					<div class="col-4 p-2">
						<label class="d-block">
							<p class="m-0"><span class="text-danger">*</span> Marcada como Leveraged en el anterior análisis</p>
							<select class="form-control form-control--disabled" disabled   v-model="form.leveraged">'
								<option value="" disabled></option>
								<option value="SI">SI</option>
								<option value="NO">NO</option>
							</select>
						</label>
					</div>
					<div class="col-4 p-2">
						<label class="d-block">
							<p class="m-0">Stage del Grupo</p>
							<input class="form-control form-control--disabled" disabled type="text" value="2017-07-19">
						</label>
					</div>
					<div class="col-4 p-2">
						<label class="d-block">
							<p class="m-0"><span class="text-danger">*</span> Cliente Cualitativo</p>
							<select class="form-control form-control--disabled" disabled  v-model="form.cualitativo">'
								<option value="" disabled></option>
								<option value="NO">NO</option>
								<option value="Venta de Armamento y Explosivos">Venta de Armamento y Explosivos</option>
								<option value="Medio de Comunicación">Medio de Comunicación</option>
								<option value="Personas Políticamente Expuestas">Personas Políticamente Expuestas</option>
								<option value="Consejeros y Miembros del Comité de Dirección de BBVA">Consejeros y Miembros del Comité de Dirección de BBVA</option>
								<option value="Riesgo Reputacional">Riesgo Reputacional</option>
								<option value="Filiales de BBVA">Filiales de BBVA</option>
								
							</select>
						</label>
					</div>
					<div class="col-4 p-2">
						<div class="d-block">
							<p class="m-0"><span class="text-danger">*</span> Cliente reestructurado o refinanciado</p>
							<input class="form-control form-control--disabled" disabled type="text" :value="form.reestructuradoRefinanciado">
						</div>
						<div v-if="form.reestructuradoRefinanciado === 'SI'">
							<label class="d-block m-0">
								<p class="m-0"><span class="text-danger">*</span> Comentarios sobre el cliente reestructurado o refinanciado</p>
								<textarea class="form-control w-100 d-block form-control--disabled" disabled rows="3" v-model="form.reestructuradoRefinanciadoComentarios"></textarea>
							</label>
						</div>
					</div>
				</div>
			</div>
			<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#collapse3" aria-expanded="true" aria-controls="collapse3">
				<div class="d-flex">
					<h1 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Accionistas</span></h1>
				</div>
			</div>
			<div id="collapse3" class="collapse hide" aria-labelledby="headingOne">
				<div class="py-4 px-5 mx-auto" v-if="showShareholders.length">
					<table class="s-table w-100 text-center">
						<thead>
							<tr>
								<th>NOMBRE</th>
								<th>PARTICIPACIÓN ACCIONARIA</th>
								<th>FINANCIAL SPONSOR</th>
								<th>AÑO</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(sh, index) in showShareholders" :key="`sh_${index}`">
								<td>{{sh.nombre}}</td>
								<td>{{sh.participacion}}%</td>
								<td>{{sh.financialSponsor}}</td>
								<td>{{sh.ano}}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="d-flex fle-wrap">
					<div class="col-4 p-2">
						<label class="d-block">
							<p class="m-0"><span class="text-danger">*</span> Tipo de compañía</p>
							<select class="form-control form-control--disabled" disabled   v-model="form.tipoCompania">'
								<option value="" disabled></option>
								<option value="Privada">Privada</option>
								<option value="Pública">Pública</option>
								<option value="Gobierno">Gobierno</option>
							</select>
						</label>
					</div>
					
				</div>
			</div>
			<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#collapse4" aria-expanded="true" aria-controls="collapse4">
				<div class="d-flex">
					<h1 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Administración</span></h1>
				</div>
			</div>
			<div id="collapse4" class="collapse hide" aria-labelledby="headingOne">
				<div class="d-flex flex-wrap">
					<div class="col-12 p-0">
						<div class="d-flex">
							<div class="col-4 p-2">
								<p class="m-0"><span class="text-danger">*</span>  Experiencia en la administración</p>
								<select class="form-control d-block form-control--disabled" disabled  v-model="form.experienciaAdministracion">'
										<option value="" disabled></option>
										<option value="De 0 a 5 años">De 0 a 5 años</option>
										<option value="De 6 a 10 años">De 6 a 10 años</option>
										<option value="Mas de 10 años">Mas de 10 años</option>
								</select>

							</div>
							<div class="col-4 p-2" v-if="form.experienciaAdministracion">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Comentarios sobre experiencia en gestión</p>
									<textarea class="form-control w-100 d-block form-control--disabled" disabled  rows="3" v-model="form.experienciaAdministracionComentarios"></textarea>
								</label>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#collapse5" aria-expanded="true" aria-controls="collapse5">
				<div class="d-flex">
					<h1 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Pricipales filiales y participadas</span></h1>
				</div>
			</div>
			<div id="collapse5" class="collapse hide" aria-labelledby="headingOne">
				<p>Datos</p>
			</div>
		</div>

		<!-- ============================================ -->
		<!-- ============================================ -->
		<!-- ============================================ -->
		<!-- ============================================ -->
		<!-- ============================================ -->
		<div class="modal s-modal fade" style="font-size: 0.8em" id="formAnalysisModal" tabindex="-1" role="dialog" aria-labelledby="formAnalysisModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-xl " role="document">
				<div class="modal-content">
				<div class="modal-header p-0">
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body" data-v-step="abe1">
					<div class="s-collapse__header" data-toggle="collapse" data-target="#collapseOne_m" aria-expanded="true" aria-controls="collapseOne_m">
						<div class="d-flex">
							<h5 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span>Path</span></h5>
						</div>
					</div>
					<div id="collapseOne_m" class="collapse show" aria-labelledby="headingOne">
						<div class="d-flex flex-wrap">
							<div class="col-12 col-md-6">
								
								<div class="h-100 py-2">
									<p class="m-0"><span class="text-danger">*</span> Template</p>
									<div>
										<select class="form-control" name="" v-model="form.path">
											<option value=""></option>
											<option value="Generico">Generico</option>
											<option value="Construcción">Construcción</option>
											<option value="Hoteles">Hoteles</option>
											<option value="Agro">Agro</option>
											<option value="Retail">Retail</option>
											<option value="Auto Retail">Auto Retail</option>
										</select>
									</div>
									<div v-if="showHelp" class="alert alert-warning" role="alert">
										<b>Nota:</b> El campo Path no debe ser editado es un campo temporal que no será visible en la versión final de ARCE.
									</div>
								</div>
							</div>
							
						</div>
					</div>



					<div class="s-collapse__header collapsed  mt-2" data-v-step="abe2" @click="showSteps('stepsAnalysisBasicEdit', 2)" data-toggle="collapse" data-target="#collapseTwo_m" aria-expanded="true" aria-controls="collapseTwo_m">
						<div class="d-flex">
							<h5 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Identificación</span></h5>
						</div>
					</div>
					<div id="collapseTwo_m" class="collapse hide" aria-labelledby="headingOne">
						<div class="d-flex flex-wrap">
							<div class="col-4 p-2">
								<label class="d-block m-0" data-v-step="abe3">
									<p class="m-0"><span class="text-danger" data-v-step="abe4">*</span> Grupo</p>
									<select class="form-control w-100" name="gupo" v-model="form.grupo">
										<option value="" disabled></option>
										<option value="Pertenece a un grupo económico">Pertenece a un grupo económico</option>
										<option value="No pertenece a un grupo económico">No pertenece a un grupo económico</option>
									</select>
								</label>
							</div>
							<div class="col-4 p-2">
								<label class="d-block m-0" data-v-step="abe45">
									<p class="m-0">Nombre del cliente</p>
									<input class="form-control form-control--disabled" disabled type="text" v-model="client.name">
								</label>
							</div>
							<div class="col-4 p-2"></div>
							<div class="col-4 p-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Comentarios <characters-available :max="500" :text="form.comentarios"></characters-available></p>
									<textarea class="form-control w-100 d-block" rows="3" v-model="form.comentarios"></textarea>
								</label>
							</div>
							<div class="col-4 p-2">
								<label class="d-block m-0">
									<p class="m-0">País Cabecera</p>
									<input class="form-control form-control--disabled" disabled type="text" v-model="client.pais_cabecera">
								</label>
							</div>
							<div class="col-4 p-2">
								<label class="d-block">
									<p class="m-0">RFC</p>
									<input class="form-control form-control--disabled" disabled type="text" v-model="client.rfc">
								</label>
							</div>
							<div class="col-4 p-2">
								<label class="d-block">
									<p class="m-0">Número de cliente</p>
									<input class="form-control form-control--disabled" disabled type="text" v-model="client.code">
								</label>
							</div>
							<div class="col-4 p-2">
								<label class="d-block">
									<p class="m-0">Sector (asset allocation)</p>
									<input class="form-control form-control--disabled" disabled type="text" value="Capital goods & Industrial services">
								</label>
							</div>
							<div class="col-4 p-2">
								<label class="d-block">
									<p class="m-0">Subsector (asset allocation)</p>
									<input class="form-control form-control--disabled" disabled type="text" value="Capital goods & Industrial services">
								</label>
							</div>
							<div class="col-4 p-2">
								<label class="d-block">
									<p class="m-0">Actividad (banxico)</p>
									<input class="form-control form-control--disabled" disabled type="text" :value="client.activity">
								</label>
							</div>
							<div class="col-4 p-2">
								<label class="d-block">
									<p class="m-0">Fundada desde</p>
									<input class="form-control form-control--disabled" disabled type="text" :value="client.since">
								</label>
							</div>
							<div class="col-4 p-2">
								<label class="d-block">
									<p class="m-0">Cliente desde</p>
									<input class="form-control form-control--disabled" disabled type="text" :value="client.clientSince">
								</label>
							</div>
							<div class="col-4 p-2">
								<label class="d-block">
									<p class="m-0"><span class="text-danger">*</span> Marcada como Leveraged en el anterior análisis</p>
									<select class="form-control"   v-model="form.leveraged">'
										<option value="" disabled></option>
										<option value="SI">SI</option>
										<option value="NO">NO</option>
									</select>
								</label>
							</div>
							<div class="col-4 p-2">
								<label class="d-block">
									<p class="m-0">Stage del Grupo</p>
									<input class="form-control form-control--disabled" disabled type="text" value="2017-07-19">
								</label>
							</div>
							<div class="col-4 p-2">
								<label class="d-block">
									<p class="m-0"><span class="text-danger">*</span> Cliente Cualitativo</p>
									<select class="form-control"  v-model="form.cualitativo">'
										<option value="" disabled></option>
										<option value="NO">NO</option>
										<option value="Venta de Armamento y Explosivos">Venta de Armamento y Explosivos</option>
										<option value="Medio de Comunicación">Medio de Comunicación</option>
										<option value="Personas Políticamente Expuestas">Personas Políticamente Expuestas</option>
										<option value="Consejeros y Miembros del Comité de Dirección de BBVA">Consejeros y Miembros del Comité de Dirección de BBVA</option>
										<option value="Riesgo Reputacional">Riesgo Reputacional</option>
										<option value="Filiales de BBVA">Filiales de BBVA</option>
									</select>
								</label>
							</div>
							<div class="col-4 p-2">
								<div class="d-block">
									<p class="m-0"><span class="text-danger">*</span> Cliente reestructurado o refinanciado</p>
									
									<div class="s-tf">
										<label class="s-tf__item">
											<input type="radio" name="cror" value="SI" v-model="form.reestructuradoRefinanciado">
											<span class="s-tf__btn">SI</span>
										</label>
										<label class="s-tf__item">
											<input type="radio" name="cror" value="NO" v-model="form.reestructuradoRefinanciado">
											<span class="s-tf__btn">NO</span>
										</label>
									</div>
								</div>
								<div v-if="form.reestructuradoRefinanciado === 'SI'">
									<label class="d-block m-0">
										<p class="m-0"><span class="text-danger">*</span> Comentarios sobre el cliente reestructurado o refinanciado</p>
										<textarea class="form-control w-100 d-block" rows="3" v-model="form.reestructuradoRefinanciadoComentarios"></textarea>
									</label>
								</div>
							</div>
						</div>
					</div>

					<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#collapse3_m" aria-expanded="true" aria-controls="collapse3_m">
						<div class="d-flex">
							<h5 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Accionistas</span></h5>
						</div>
					</div>
					<div id="collapse3_m" class="collapse hide" aria-labelledby="headingOne">
						<div class="py-4 px-5 mx-auto" v-if="showShareholders.length">
							<table class="s-table w-100 text-center">
								<thead>
									<tr>
										<th>NOMBRE</th>
										<th>PARTICIPACIÓN ACCIONARIA</th>
										<th>FINANCIAL SPONSOR</th>
										<th>AÑO</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(sh, index) in showShareholders" :key="`sh_${index}`">
										<td>{{sh.nombre}}</td>
										<td>{{sh.participacion}}%</td>
										<td>{{sh.financialSponsor}}</td>
										<td>{{sh.ano}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="d-flex flex-wrap py-2">
							<div class="col-12">
								<button class="s-btn s-btn--primary s-btn--outline" @click="openModalShareholders">Administrar Accionistas</button>
							</div>
						</div>
						<div class="d-flex fle-wrap">
							<div class="col-4 p-2">
								<label class="d-block">
									<p class="m-0"><span class="text-danger">*</span> Tipo de compañía</p>
									<select class="form-control"   v-model="form.tipoCompania">'
										<option value="" disabled></option>
										<option value="Privada">Privada</option>
										<option value="Pública">Pública</option>
										<option value="Gobierno">Gobierno</option>
									</select>
								</label>
							</div>
							<!-- <div class="col-4 p-2">
								<div class="d-block">
									<p class="m-0"><span class="text-danger">*</span>  ¿Posibles discrepancias / conflictos entre socios ?</p>
									<div class="s-tf">
										<label class="s-tf__item">
											<input type="radio" name="pdcs" value="SI" v-model="form.coflictosSocios">
											<span class="s-tf__btn">SI</span>
										</label>
										<label class="s-tf__item">
											<input type="radio" name="pdcs" value="NO" v-model="form.coflictosSocios">
											<span class="s-tf__btn">NO</span>
										</label>
									</div>
								</div>
								<div v-if="form.coflictosSocios === 'SI'">
									<label class="d-block m-0">
										<p class="m-0"><span class="text-danger">*</span> Comentarios sobre conflictos / discrepancias entre socios</p>
										<textarea class="form-control w-100 d-block" rows="3" v-model="form.coflictosSociosComentarios"></textarea>
									</label>
								</div>
							</div>
							<div class="col-4 p-2">
								<div class="d-block">
									<p class="m-0"><span class="text-danger">*</span>  ¿Movimiento significaticvo en el accionariado del cliente?</p>
									<div class="s-tf">
										<label class="s-tf__item">
											<input type="radio" name="msac" value="SI" v-model="form.movimientoAccionariado">
											<span class="s-tf__btn">SI</span>
										</label>
										<label class="s-tf__item">
											<input type="radio" name="msac" value="NO" v-model="form.movimientoAccionariado">
											<span class="s-tf__btn">NO</span>
										</label>
									</div>
								</div>
								<div v-if="form.movimientoAccionariado === 'SI'">
									<label class="d-block m-0">
										<p class="m-0"><span class="text-danger">*</span> Comentarios sobre movimientos de accionistas</p>
										<textarea class="form-control w-100 d-block" rows="3" v-model="form.movimientoAccionariadoComentarios"></textarea>
									</label>
								</div>
							</div> -->
						</div>
					</div>
					<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#collapse4" aria-expanded="true" aria-controls="collapse4">
						<div class="d-flex">
							<h5 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Administración</span></h5>
						</div>
					</div>
					<div id="collapse4" class="collapse hide" aria-labelledby="headingOne">
						<div class="d-flex flex-wrap">
							<div class="col-12 p-0">
								<div class="d-flex">
									<div class="col-4 p-2">
										<p class="m-0"><span class="text-danger">*</span>  Experiencia en la administración</p>
										<select class="form-control d-block"   v-model="form.experienciaAdministracion">'
												<option value="" disabled></option>
												<option value="De 0 a 5 años">De 0 a 5 años</option>
												<option value="De 6 a 10 años">De 6 a 10 años</option>
												<option value="Mas de 10 años">Mas de 10 años</option>
										</select>`

									</div>
									<div class="col-4 p-2" v-if="form.experienciaAdministracion">
										<label class="d-block m-0">
											<p class="m-0"><span class="text-danger">*</span> Comentarios sobre experiencia en gestión</p>
											<textarea class="form-control w-100 d-block" rows="3" v-model="form.experienciaAdministracionComentarios"></textarea>
										</label>
									</div>
								</div>
							</div>
							<!-- <div class="col-4 p-2">
								<p class="m-0"><span class="text-danger">*</span> Agresividad toma de decisiones de riesgo</p>
								<select class="form-control"   v-model="form.agresividadRiesgo">'
										<option value="" disabled></option>
										<option value="Agresivo">Agresivo</option>
										<option value="Medio">Medio</option>
										<option value="Conservador">Conservador</option>
								</select>
								<div v-if="form.agresividadRiesgo == 'Agresivo'">
										<label class="d-block m-0">
											<p class="m-0"><span class="text-danger">*</span> Comentarios sobre agresividad de la gestión</p>
											<textarea class="form-control w-100 d-block" rows="3" v-model="form.agresividadRiesgoComentarios"></textarea>
										</label>
								</div>
							</div> -->
							<!-- <div class="col-4 p-2">
								<p class="m-0"><span class="text-danger">*</span> Tipo de administración</p>
								<select class="form-control"   v-model="form.tipoAdministracion">'
										<option value="" disabled></option>
										<option value="Administrador Único">Administrador Único</option>
										<option value="Consejo de Adminitración">Consejo de Adminitración</option>
										<option value="Familiar">Familiar</option>
								</select>
								<div v-if="form.tipoAdministracion">
										<label class="d-block m-0">
											<p class="m-0"><span class="text-danger">*</span> Comentarios sobre estilo de gestión</p>
											<textarea class="form-control w-100 d-block" rows="3" v-model="form.tipoAdministracionComentarios"></textarea>
										</label>
								</div>
							</div> -->
						</div>
					</div>
					
				</div>
				<div class="modal-footer">
					<button type="button" class="s-btn s-btn--outline" data-dismiss="modal" data-v-step="abe6">Cancelar</button>
					<button type="button" class="s-btn s-btn--primary" data-dismiss="modal" data-v-step="abe7" @click="save">Guardar</button>
				</div>
				</div>
			</div>
		</div>
		<div class="modal s-modal fade" id="accionistasModal" tabindex="-1" role="dialog" aria-labelledby="accionistasModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-xl" role="document">
				<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title w-100 text-center" id="accionistasModalLabel">Administrar Accionistas</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="d-flex" v-for="(sh, index) in shareholdersForm" :key="`sh_${index}`">
						<div class="col-3 mt-auto">
							<div class="position-relative">
								<div class="position-relative">
									<div class="s-input" data-v-step="cs1">
										<input v-if="!sh.nombre" class="form-control w-100" type="text" v-model="sh.query">
										<input v-else class="form-control w-100" disabled type="text" v-model="sh.nombre">
										<svg-icon class="mx-2" name="search" />
										<span class="m-0" @click="sh.nombre = ''" v-if="sh.nombre">
											<svg-icon class="mx-2 s-input__delete" name="close" />
										</span>
									</div>
									
								</div>
								<div v-if="sh.query" class="s-query-result">
									<div class="d-flex" @click="sh.nombre = sh.query, sh.query = ''">
										<button class="s-query-btn my-auto">
											<svg-icon name="add" />
										</button>
										<div class="ml-2 my-auto">
											<p class="small m-0">Create new arce...</p>
											<p class="m-0 small">{{sh.query}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-2 mt-auto">
							<p class="m-0"> 
								% de Participación
							</p>
							<input class="form-control w-100" type="text" v-model="sh.participacion">
						</div>
						<div class="col-3 mt-auto">
							<p class="m-0"> 
								Financial Sponsor
							</p>
							<select class="form-control" v-model="sh.financialSponsor">
								<option value="">--Ninguno--</option>
								<option value="SI">SI</option>
								<option value="NO">NO</option>
							</select>
						</div>
						<div class="col-3 mt-auto">
							<p class="m-0"> 
								Año
							</p>
							<input class="form-control w-100" type="text" v-model="sh.ano">
						</div>
						<div class="col-1 mt-auto">
							<button v-if="shareholders.length > 1" @click="deleteItem(index)" class="s-btn s-btn--transparent">
								<svg-icon name="delete" />
							</button>
						</div>
					</div>
					<div class="text-right">
						<button @click="addNew" class="s-query-btn my-auto mr-5">
							<svg-icon name="add" />
						</button>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" @click="saveAllShareholders" class="s-btn s-btn--primary">Save all</button>
				</div>
				</div>
			</div>
		</div>
		
	</div>
</template>
